<div class="modal-header" style="display:flex;">
    <h3 class="modal-title">Manage Expense Categories</h3>
    <span *ngIf="lastSave.status === 'success' && lastSave.time != null" class="badge badge-success" [ngClass]="{fade: labelFade}">Save Successful - {{lastSave.time}}</span>
    <span *ngIf="lastSave.status !== 'success' && lastSave.time != null" class="badge badge-danger" [ngClass]="{fade: labelFade}">Save Fail - {{lastSave.time}}</span>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-6">
            <label><strong>Category Name</strong></label>
            <input type="text" class="form-control" [(ngModel)]="formData.newName" style="resize:none" />
        </div>
        <div class="col-lg-4">
            <button type="button" class="btn btn-success buttonNoLabel" (click)="addCat()" [disabled]="formData.newName === '' || formData.newName == null">Add</button>
        </div>
    </div>
    <hr />
    <div *ngIf="catList?.length < 1">Please add a category from the top.</div>
    <table class="table" *ngIf="catList?.length > 0">
        <thead>
            <tr>
                <th class="col-lg-6"><div style="margin-bottom:5px;">Category Name</div></th>
                <th class="col-lg-2"><div style="margin-bottom:5px;">Active</div></th>
                <th class="col-lg-4"><div style="margin-bottom:5px;"></div></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of catList">
                <td class="col-lg-6">
                    <div style="margin-bottom:5px;">
                        <input type="text" class="form-control" [(ngModel)]="data.ExpenseCatgName" (blur)="updateCat(data)" />
                    </div>
                </td>
                <td class="col-lg-2">
                    <div style="margin-bottom:5px;">
                        <input type="checkbox" class="form-control" [(ngModel)]="data.IsActive" (blur)="updateCat(data)" style="width:25px;height:25px;" />
                    </div>
                </td>
                <td class="col-lg-4">
                    <div style="margin-bottom:5px;" *ngIf="data.deleteTrigger">
                        <button type="button" class="btn btn-outline-primary" (click)="deleteTrigger(data, 'no')">Cancel</button>
                        <button type="button" class="btn btn-danger" (click)="deleteCat(data)">Delete</button>
                    </div>
                    <div style="margin-bottom:5px;" *ngIf="!data.deleteTrigger">
                        <button type="button" class="btn btn-danger btn-icon-only" (click)="deleteTrigger(data, 'yes')"><i class="modus-icons" aria-hidden="true">trash</i></button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>